export default "__VITE_ASSET__76a69ea5__"